import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  Button,
  LoadingIndicator,
  Select
} from "../../../../components/simple";

import { PLATFORMS } from "../platforms";
import Api from "../../../../api";
// import { audiencesCreateWithoutTemplate } from "../../../../router/routes";
import styles from "../push-modal.module.scss";

// const usePrevious = value => {
//   const ref = useRef();
//   useEffect(() => {
//     ref.current = value;
//   });
//   return ref.current;
// };
import usePrevious from "../../../../hooks/usePrev";
import LabelForRow from "../../../../components/forms/LabelForRow";

// eslint-disable-next-line react/prefer-stateless-function
const Snapchat = ({
  // audienceType,
  // editAudienceHandler,
  selectedPlatform,
  // adsetId,
  handlePushToPlatform,
  // handleAdsetIdChange,
  handleSignin
  // allowEdit
}) => {
  const [snapchatIsAuthorized, setSnapchatIsAuthorized] = useState(false);

  const [selectedData, setSelectedData] = useState({
    organizationId: "",
    adAccountId: "",
    campaignId: "",
    adSetId: ""
  });

  const [responseData, setResponseData] = useState({
    organizations: [],
    adAccounts: [],
    campaigns: [],
    adSets: []
  });

  const [responseErrorMessage, setResponseErrorMessage] = useState({
    organizations: "",
    adAccounts: "",
    campaigns: "",
    adSets: ""
  });

  const prevSelectedData = usePrevious(selectedData);

  const platforms = useSelector(state => state.platforms);

  useEffect(() => {
    const checkSnapchatIsAuthorized = async () => {
      await Api.platforms.snapchat
        .isAuthorized()
        .then(res => {
          if (res?.valid) {
            setSnapchatIsAuthorized(true);
          } else {
            setSnapchatIsAuthorized(false);
          }
        })
        .catch(error => {
          console.log(error);
        });
    };

    checkSnapchatIsAuthorized();
  }, []);

  useEffect(() => {
    if (!snapchatIsAuthorized || responseErrorMessage.organizations) return;

    const getOrganizations = async () => {
      // setSelectedData({
      //   organizationId: "",
      //   adAccountId: "",
      //   campaignId: "",
      //   adSetId: "",
      // });

      // setResponseErrorMessage((prevState) => ({
      //   ...prevState,
      //   organizationId: "",
      // }));

      try {
        const organizations = await Api.platforms.snapchat.getOrganizations();

        if (organizations.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            organizations: organizations.message
          }));

          setResponseData({
            organizations: [],
            adAccounts: [],
            campaigns: [],
            adSets: []
          });

          return;
        }

        setResponseData({
          organizations,
          adAccounts: [],
          campaigns: [],
          adSets: []
        });
      } catch (error) {
        console.log(error);
      }
    };

    const getAdAccounts = async organizationId => {
      setSelectedData(prevData => ({
        ...prevData,
        adAccountId: "",
        campaignId: "",
        adSetId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        adAccounts: ""
      }));

      try {
        const adAccounts = await Api.platforms.snapchat.getAdAccounts({
          organizationId
        });

        if (adAccounts.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            adAccounts: adAccounts.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            adAccounts: [],
            campaigns: [],
            adSets: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          adAccounts,
          campaigns: [],
          adSets: []
        }));
      } catch (error) {
        console.log(error);
      }
    };

    const getCampaigns = async adAccountId => {
      setSelectedData(prevData => ({
        ...prevData,
        campaignId: "",
        adSetId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        campaigns: ""
      }));

      try {
        const campaigns = await Api.platforms.snapchat.getCampaigns({
          adAccountId
        });

        if (campaigns.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            campaigns: campaigns.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            campaigns: [],
            adSets: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          campaigns,
          adSets: []
        }));
      } catch (error) {
        console.log(error);
      }
    };

    const getAdSets = async campaignId => {
      setSelectedData(prevData => ({
        ...prevData,
        adSetId: ""
      }));

      setResponseErrorMessage(prevState => ({
        ...prevState,
        adSets: ""
      }));

      try {
        const adSets = await Api.platforms.snapchat.getAdSets({
          campaignId
        });

        if (adSets.message) {
          setResponseErrorMessage(prevState => ({
            ...prevState,
            adSets: adSets.message
          }));

          setResponseData(prevData => ({
            ...prevData,
            adSets: []
          }));

          return;
        }

        setResponseData(prevData => ({
          ...prevData,
          adSets
        }));
      } catch (error) {
        console.log(error);
      }
    };

    if (!responseData.organizations.length) getOrganizations();

    if (
      prevSelectedData.organizationId !== selectedData.organizationId &&
      selectedData.organizationId
    ) {
      getAdAccounts(selectedData.organizationId);
    }

    if (
      prevSelectedData.adAccountId !== selectedData.adAccountId &&
      selectedData.adAccountId
    ) {
      getCampaigns(selectedData.adAccountId);
    }

    if (
      prevSelectedData.campaignId !== selectedData.campaignId &&
      selectedData.campaignId
    ) {
      getAdSets(selectedData.campaignId);
    }
  }, [
    snapchatIsAuthorized,
    selectedData,
    responseData,
    prevSelectedData,
    responseErrorMessage
  ]);

  const handleSelectChange = (name, value) => {
    setSelectedData(prevData => ({
      ...prevData,
      [`${name}Id`]: value
    }));
  };

  const onSubmitHandler = e => {
    e.preventDefault();

    if (selectedData.adSetId)
      handlePushToPlatform(PLATFORMS.snapchat, {
        adsetId: selectedData.adSetId
      });
  };

  return (
    <>
      <div
        className={` ${styles["snapchat-signin"]} ${
          selectedPlatform === "snapchat" ? styles["slide-from-right"] : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <SVG.Snapchat width={40} height={40} /> Snapchat */}
        {/* </div> */}

        {snapchatIsAuthorized ? (
          <>
            <div>
              <form onSubmit={onSubmitHandler}>
                {!responseErrorMessage.organizations ? (
                  <div>
                    <LabelForRow
                      label="Choose the organization"
                      title="Pick Organization"
                    />
                    <Select
                      value={
                        selectedData.organizationId
                          ? {
                              label: "organization",
                              value: selectedData.organizationId
                            }
                          : ""
                      }
                      selectForThePushForm
                      className="push-platform"
                      isSearchable
                      label="Organization"
                      placeholder="Organization"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.organizations}
                      name="organization"
                      handleChange={handleSelectChange}
                      required
                    />
                  </div>
                ) : (
                  <div />
                  // <p
                  //   className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  // >
                  //   {responseErrorMessage.organizations}
                  // </p>
                )}

                {!responseErrorMessage.adAccounts ? (
                  <div>
                    <LabelForRow
                      label="Choose the ad account your campaign are related to"
                      title="Pick Ad Account"
                    />
                    <Select
                      value={
                        selectedData.adAccountId
                          ? {
                              label: "adAccount",
                              value: selectedData.adAccountId
                            }
                          : ""
                      }
                      isSearchable
                      selectForThePushForm
                      label="Ad Account"
                      placeholder="Ad Account"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.adAccounts}
                      name="adAccount"
                      handleChange={handleSelectChange}
                      isDisabled={!responseData.adAccounts.length}
                      required
                    />
                  </div>
                ) : (
                  <p
                    className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  >
                    {responseErrorMessage.adAccounts}
                  </p>
                )}

                {!responseErrorMessage.campaigns ? (
                  <div>
                    <LabelForRow
                      label="Choose the campaign the audience needs to be added to"
                      title="Pick Campaign"
                    />
                    <Select
                      isSearchable
                      selectForThePushForm
                      label="Campaign"
                      placeholder="Campaign Name"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.campaigns}
                      name="campaign"
                      handleChange={handleSelectChange}
                      isDisabled={!responseData.campaigns.length}
                      required
                    />
                  </div>
                ) : (
                  <p
                    className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  >
                    {responseErrorMessage.campaigns}
                  </p>
                )}

                {!responseErrorMessage.adSets ? (
                  <div>
                    <LabelForRow
                      label="Choose the adset the audience needs to be added to"
                      title="Pick Adset"
                    />
                    <Select
                      isSearchable
                      selectForThePushForm
                      label="AdSet"
                      placeholder="Adset Name"
                      optionLabel="name"
                      optionValue="id"
                      options={responseData.adSets}
                      name="adSet"
                      handleChange={handleSelectChange}
                      isDisabled={!responseData.adSets.length}
                      required
                    />
                  </div>
                ) : (
                  <p
                    className={`${styles["select-error-mesage"]} mb-4 text-danger`}
                  >
                    {responseErrorMessage.adSets}
                  </p>
                )}

                {platforms?.isLoading ? (
                  <div
                    style={{ marginTop: "32px" }}
                    className="mt-4 d-flex justify-content-center"
                  >
                    <LoadingIndicator />
                  </div>
                ) : (
                  <div className={styles.button_container}>
                    <Button
                      disabled={!selectedData.adSetId}
                      type="submit"
                      className={styles["push-audience-btn"]}
                    >
                      <span>Push</span>
                    </Button>
                    {/* {audienceType === "audience" && allowEdit && ( */}
                    {/*  <Button */}
                    {/*    type="button" */}
                    {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
                    {/*    onClick={editAudienceHandler} */}
                    {/*  > */}
                    {/*    <span>Edit audience</span> */}
                    {/*  </Button> */}
                    {/* )} */}
                  </div>
                )}
              </form>
            </div>
          </>
        ) : (
          <div>
            <div className={styles["connect-account"]}>Connect Account</div>
            <Button
              className={styles["platform-signin-button"]}
              onClick={() => {
                handleSignin(PLATFORMS.snapchat);
              }}
            >
              Sign in to Snapchat
            </Button>
          </div>
        )}
        <div className={styles["platform-description"]}></div>
      </div>
    </>
  );
};

Snapchat.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  selectedPlatform: PropTypes.string,
  handlePushToPlatform: PropTypes.func,
  // editAudienceHandler: PropTypes.func.isRequired,
  handleSignin: PropTypes.func
  // allowEdit: PropTypes.bool.isRequired
};

Snapchat.defaultProps = {
  selectedPlatform: "",
  handlePushToPlatform: () => {},
  handleSignin: () => {}
};

export default Snapchat;
